import React, { useState, useEffect, useRef, useCallback } from "react";
import { API_BASE_URL } from "../config";
import { Modal, Container, Row, Col, Button, Card, Form } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import "react-calendar/dist/Calendar.css";
import "./CalendarUI.css";
import Navbar from "../components/Navbar";
import { useLoading } from "../contexts/LoadingContext";
import Loader from "../components/loader";
import { FaTimes, FaChevronLeft } from "react-icons/fa";

const SelectAppointment = () => {
  const [doctorProfile, setDoctorProfile] = useState(null);
  const [showFullAbout, setShowFullAbout] = useState(false);
  const { isLoading, setIsLoading } = useLoading();
  const [loadingSlots, setLoadingSlots] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [selectedTimeNumber, setSelectedSlotNumber] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [daysArray, setDaysArray] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);

  const [walletBalance, setWalletBalance] = useState();
  const [isChecked, setIsChecked] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [isCouponApplied, setIsCouponApplied] = useState(false);

  const daysContainerRef = useRef(null);
  const { id } = useParams();
  const location = useLocation();

  const navigate = useNavigate();
  const [doctorInfo, setDoctorInfo] = useState({
    id: location.state?.id || "",
    consultationType: "Video",
    fee: location.state?.fee || 500,
    isDiscount: location.state?.isDiscount || 0,
    discount: location.state?.discount || 0,
    status: "Unpaid",
    currency: location.state?.currency || "PKR",
  });

  console.log("doctorInfo:", doctorInfo);

  // Generate the initial list of dates for the calendar
  const generateInitialDaysArray = () => {
    const initialDays = [];
    const today = new Date();
    for (let i = 0; i < 32; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      initialDays.push(date);
    }
    return initialDays;
  };

  useEffect(() => {
    setDaysArray(generateInitialDaysArray());
  }, []);

  // Fetch available time slots when the selected date changes
  useEffect(() => {
    const fetchTimeSlots = async () => {
      setLoadingSlots(true);
      const dayOfWeek = selectedDate.toLocaleString("en-US", {
        weekday: "long",
      });
      const appointmentDate = selectedDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD

      try {        const response = await axios.get(
          `${API_BASE_URL}/slots/list`,
          {
            params: {
              doctorId: id,
              dayOfWeek,
              appointmentDate,
            },
          }
        );

        if (response.data.statusCode === 1) {
          setTimeSlots(response.data.payLoad);
        } else {
          setTimeSlots([]);
          throw new Error("Failed to fetch time slots");
        }
      } catch (error) {
        setTimeSlots([]);
        console.error("Error fetching time slots:", error);
        // Swal.fire("Error!", "Failed to load time slots.", "error");
      } finally {
        setLoadingSlots(false);
      }
    };

    fetchTimeSlots();
  }, [selectedDate]);

  // const handleTimeSlotClick = (slot, idx) => {
  //   setSelectedSlotNumber(idx);
  //   setSelectedTimeSlot(slot);
  //   setShowModal(true);
  // };

  const handleTimeSlotClick = (slot, idx) => {
    setSelectedSlotNumber(idx);
    setSelectedTimeSlot(slot);
    setShowModal(true);

    setIsChecked(false);
    setCouponCode("");
    setIsCouponApplied(false);
    setDoctorInfo(prev => ({
      ...prev,
      fee: location.state?.fee || 500, // reset to original
      isDiscount: 0,
      discount: 0
    }));
  };

  const checkWalletBalance = async () => {
    const session = JSON.parse(sessionStorage.getItem("user"));
    const patientId = session?.payLoad?.user?.Id;

    if (!patientId) {
      console.warn("Patient ID is missing");
      return;
    }

    setIsLoading(true)
    try {
      const response = await fetch(`${API_BASE_URL}/wallet/balance?patientId=${patientId}`, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Wallet balance response:", data);

      if (data.statusCode === 1) {
        const balance = data.payLoad?.balance;
        console.log("Wallet balance is:", balance);
        setWalletBalance(balance)
        // set some state if needed
      } else {
        console.warn("Failed to fetch balance:", data.statusMessage?.[0]);
      }
    } catch (error) {
      console.error("Error fetching wallet balance:", error);
    }
  };

  useEffect(() => {
    checkWalletBalance()
  }, [])

  const handleModalClose = () => {
    setShowModal(false);
    setPhoneNumber("");
  };

  const handleContinue = async () => {
    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(selectedDate.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    // Get the day of the week
    const options = { weekday: "long" };
    const dayOfWeek = selectedDate.toLocaleDateString(undefined, options);

    const session = JSON.parse(sessionStorage.getItem("user"));

    if (!session?.payLoad.access_token) {
      Swal.fire({
        icon: "info",
        title: "Login",
        text: "Please login first",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      }).then(() => {
        navigate(`/login/appointment`);
        return;
      });
    }

    const profileId = session.payLoad.user.Id;
    const packageId = 1126;

    // Use discounted fee if applicable (discount is percent)
    let feeToPay = doctorInfo.fee;
    if (doctorInfo.isDiscount === 1 && doctorInfo.discount > 0) {
      feeToPay = Math.round(
        doctorInfo.fee - (doctorInfo.fee * doctorInfo.discount) / 100
      );
    }

    const fee = Number(feeToPay);
    const wallet = Number(walletBalance);

    if (fee <= wallet) {

      const queryString = new URLSearchParams({
        session_id: "wallet",
        profile_id: profileId,
        doctor_id: doctorInfo.id,
        appointmentDate: formattedDate, // Use formatted string
        appointmentTime: selectedTimeSlot,
        slotNumber: selectedTimeNumber,
        paymentMethod: "wallet",
        walletBalance: walletBalance,
        couponCode: couponCode || "",
        price: feeToPay
      }).toString();

      navigate(`/appointment-payment-success?${queryString}`);

    }

    else if (fee > wallet && wallet !== 0) {

      const newFee = fee - wallet

      try {
        const response = await axios.get(
          `${API_BASE_URL}/stripe/appointment-payment`,
          {
            params: {
              profile_id: profileId,
              doctor_id: id,
              // package_id: packageId,
              price: newFee,
              currency: doctorInfo.currency, // Pass currency to the API
              appointmentDate: formattedDate,
              appointmentTime: selectedTimeSlot,
              dayOfWeek: dayOfWeek,
              slotNumber: selectedTimeNumber,
              paymentMethod: "mixed",
              walletBalance: walletBalance,
              couponCode: couponCode || "",
            },
          }
        );

        if (response.data.statusCode === 1) {
          handleModalClose();
          const paymentUrl = response.data.payLoad.url;
          if (paymentUrl) {
            window.location.href = paymentUrl;
          } else {
            throw new Error("Payment URL not found.");
          }
        } else {
          throw new Error("Failed to initiate payment.");
        }
      } catch (err) {
        console.error(err);
      }
    }

    else {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/stripe/appointment-payment`,
          {
            params: {
              profile_id: profileId,
              doctor_id: id,
              // package_id: packageId,
              price: feeToPay,
              currency: doctorInfo.currency, // Pass currency to the API
              appointmentDate: formattedDate,
              appointmentTime: selectedTimeSlot,
              dayOfWeek: dayOfWeek,
              slotNumber: selectedTimeNumber,
              paymentMethod: "stripe",
              walletBalance: walletBalance,
              couponCode: couponCode || ""
            },
          }
        );

        if (response.data.statusCode === 1) {
          handleModalClose();
          const paymentUrl = response.data.payLoad.url;
          if (paymentUrl) {
            window.location.href = paymentUrl;
          } else {
            throw new Error("Payment URL not found.");
          }
        } else {
          throw new Error("Failed to initiate payment.");
        }
      } catch (err) {
        console.error(err);
      }
    }

  };

  const formatDate = (date) => {
    const options = { weekday: "short", day: "numeric", month: "short" };
    return date.toLocaleDateString(undefined, options);
  };

  const scrollLeft = () => {
    daysContainerRef.current.scrollBy({ left: -200, behavior: "smooth" });
  };

  const scrollRight = () => {
    daysContainerRef.current.scrollBy({ left: 200, behavior: "smooth" });
  };

  useEffect(() => {
    const fetchDoctorProfile = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}/specialist/view?user_id=${id}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch doctor profile");
        }
        const data = await response.json();
        if (data.statusCode === 1 && data.payLoad) {
          setDoctorProfile(data.payLoad);
        } else {
          throw new Error("Invalid response format");
        }
      } catch (error) {
        console.error("Error fetching doctor profile:", error);
        Swal.fire("Error!", "Failed to load doctor profile.", "error");
      } finally {
        setIsLoading(false);
      }
    };

    fetchDoctorProfile();
  }, [id, setIsLoading]);

  const onDoctorProfile = useCallback(
    (id) => {
      navigate(`/doctor-profile/${id}`);
    },
    [navigate]
  );

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleCouponSubmit = async () => {
    if (!couponCode) {
      Swal.fire("Oops!", "Please enter a coupon code.", "warning");
      return;
    }

    setIsLoading(true)
    const session = JSON.parse(sessionStorage.getItem("user"));
    const patientId = session?.payLoad?.user?.Id;

    try {
      const response = await fetch(`${API_BASE_URL}/slots/check-follow`, {
        method: "POST",
        body: JSON.stringify({
          patientId: patientId,
          doctorId: doctorInfo.id,
          couponCode: couponCode
        })
      });

      const result = await response.json();

      if (result.statusCode === 1) {
        setIsLoading(false)
        Swal.fire("Success!", "Coupon validated successfully!", "success");

        // Apply 50% discount
        setDoctorInfo(prev => {
          const newFee = prev.fee * 0.5;
          console.log("Discounted fee:", newFee);
          return {
            ...prev,
            fee: newFee,
          };
        });
        setIsCouponApplied(true);
      } else {
        setIsLoading(false)
        Swal.fire("Invalid", "Invalid Coupon Code", "error");
      }
    } catch (error) {
      setIsLoading(false)
      console.error("API Error:", error);
      Swal.fire("Error", "Something went wrong while validating the coupon.", "error");
    }
  };


  if (isLoading) {
    return (
      <>
        <Navbar />
        <Container>
          <Loader type="selectedappointment" count={1} />
        </Container>
      </>
    );
  }

  if (!doctorProfile) {
    return (
      <>
        <Navbar />
        <Container>
          <div className="text-center mt-4">
            <h3>Doctor not found</h3>
          </div>
        </Container>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="day-scrolling-calendar">
              <div className=" mb-2">
                <Button
                  variant="primary"
                  size="sm"
                  className="d-flex align-items-center gap-1 justify-content-center"
                  style={{ width: "80px" }}
                  onClick={() => navigate(-1)}
                >
                  <FaChevronLeft />
                  Back
                </Button>
              </div>
              <Card className="shadow-lg border-0 rounded mb-3">
                <div className="d-flex align-items-center">
                  <Col
                    md={5}
                    lg={3}
                    sm={12}
                    xs={5}
                    className="text-center mb-4 mb-md-0"
                  >
                    <img
                      src={doctorProfile.ImgLink}
                      alt="Doctor Profile"
                      className="img-fluid rounded-circle border border-light"
                      style={{ width: "70px", height: "70px" }}
                    />
                    {/* <span
                        class="badge bg-secondary"
                        onClick={() =>
                          onDoctorProfile(id)
                        }
                      >
                        See Profile
                      </span> */}
                  </Col>
                  <Col md={7} sm={12} xs={7} className="text-left mt-md-2">
                    <Row>
                      <h5 className="mb-0">{doctorProfile.FirstName}</h5>
                    </Row>
                    <Row>
                      <div>
                        <span className="badge bg-warning text-dark">
                          {doctorProfile.AverageRating
                            ? doctorProfile.AverageRating.toFixed(1)
                            : "N/A"}
                        </span>
                        <span className="text-muted">
                          {" "}
                          ({doctorProfile.RatingCount} reviews)
                        </span>
                      </div>
                    </Row>
                    <Card.Body>
                      <Card.Text className="mb-4" style={{ fontSize: "15px" }}>
                        <strong>Experience:</strong> {doctorProfile.Experience}
                        <br />
                        <strong>Duty Time:</strong>{" "}
                        {doctorProfile.DoctorDutyTime}
                        <br />
                        <strong>Qualifications:</strong>{" "}
                        {doctorProfile.Allqualifications}
                      </Card.Text>
                    </Card.Body>
                  </Col>
                </div>
              </Card>
              {/* Navigation Arrows */}
              <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
                <div className="arrow-left">
                  <button
                    className="arrow-btn-appointment"
                    onClick={scrollLeft}
                  >
                    &lt;
                  </button>
                </div>
                <div className="arrow-right">
                  <button
                    className="arrow-btn-appointment"
                    onClick={scrollRight}
                  >
                    &gt;
                  </button>
                </div>
              </div>
              {/* Horizontal Scrollable Day Picker */}
              <div className="days-container" ref={daysContainerRef}>
                <div className="days-list ">
                  {daysArray.map((date, idx) => (
                    <button
                      key={idx}
                      className={`day-item btn ${selectedDate.toDateString() === date.toDateString()
                        ? "btn-primary"
                        : "bg-light text-dark shadow-sm border"
                        }`}
                      onClick={() => setSelectedDate(date)}
                    >
                      {formatDate(date)}
                    </button>
                  ))}
                </div>
              </div>
              {/* Display Time Slots for Selected Date */}{" "}
              <div className="time-slots-container mt-4">
                <h5>Available Time Slots for {selectedDate.toDateString()}</h5>
                <div className="time-slots">
                  {loadingSlots ? (
                    <Row>
                      {[...Array(8)].map((_, idx) => (
                        <Col key={idx} xs={3} className="mb-3">
                          <Skeleton height={40} width="90%" />
                        </Col>
                      ))}
                    </Row>
                  ) : timeSlots.length > 0 ? (
                    timeSlots.map((slot) => (
                      <button
                        key={slot.slot_no}
                        className="time-slot btn btn-outline-primary shadow-sm border m-2"
                        onClick={() =>
                          handleTimeSlotClick(slot.time, slot.slot_no)
                        }
                      >
                        {slot.time}
                      </button>
                    ))
                  ) : (
                    <p>
                      No availability found for the specified doctor and day.
                    </p>
                  )}
                </div>
                {/* <div className="time-slots">
                  {timeSlots.length > 0 ? (
                    timeSlots.map((slot, idx) => (
                      <button
                        key={idx}
                        className="time-slot btn btn-outline-primary m-2"
                        onClick={() => handleTimeSlotClick(slot)}
                      >
                        {slot}
                      </button>
                    ))
                  ) : (
                    <p>No available time slots</p>
                  )}
                </div> */}
              </div>
              {/* Modal for phone number input */}
              <Modal show={showModal} onHide={handleModalClose} centered size="lg">
                <Modal.Header>
                  <Modal.Title>Confirm Your Appointment</Modal.Title>
                  <FaTimes
                    onClick={handleModalClose}
                    style={{
                      cursor: "pointer",
                      marginLeft: "auto",
                      fontSize: "1.5rem",
                      color: "#50C4CC ",
                    }}
                  />
                </Modal.Header>

                <Modal.Body>
                  {/* Doctor information layout with two columns */}
                  <div className="container">
                    <div className="row">
                      {/* Left Column - Doctor Image and Info */}
                      <div className="col-md-4 d-flex flex-column align-items-center justify-content-center">
                        <img
                          src={doctorProfile.ImgLink}
                          alt="Doctor"
                          className="img-fluid rounded-circle doctor-image-modal"
                          style={{ width: "150px", height: "150px" }}
                        />
                        <p className="doctor-modal-name text-center">
                          <strong>{doctorProfile.FirstName}</strong>
                        </p>
                        <p className="doctor-modal-name text-center text-muted">
                          {doctorProfile.Allqualifications}
                        </p>
                        <p className="doctor-modal-name text-center text-muted">
                          {doctorProfile.specialty}
                        </p>
                      </div>

                      {/* Right Column - Doctor Details */}
                      <div className="col-md-8">
                        <p className="doctor-modal p-3">
                          <h5>Consultation Info</h5>
                          <br />
                          <strong>Consultation Type</strong>
                          <span className="text-muted float-end">
                            {doctorInfo.consultationType}
                          </span>
                          <br />
                          <strong>Selected Date</strong>
                          <span className="text-muted float-end">
                            {formatDate(selectedDate)}
                          </span>
                          <br />
                          <strong>Time Slot</strong>
                          <span className="text-muted float-end">
                            {selectedTimeSlot ? selectedTimeSlot : ""}
                          </span>
                        </p>
                        <p className="doctor-modal p-3 d-flex flex-column">
                          <h5>Payment Info</h5>
                          <div className="d-flex flex-column gap-2 w-100 mb-1">
                            <div className="d-flex justify-content-between">
                              <span>
                                <strong>Fee:</strong>
                              </span>
                              <span className="text-muted">
                                {/* {Number(doctorInfo.fee).toLocaleString("en-US")} {doctorInfo.currency || "PKR"} */}
                                {Number(doctorInfo.fee).toLocaleString("en-US")} {"PKR"}
                              </span>
                            </div>

                            {/* {doctorInfo.isDiscount === 1 &&
                              doctorInfo.discount > 0 && (
                                <>
                                  <div className="d-flex justify-content-between">
                                    <span>
                                      <strong>Discount:</strong>
                                    </span>
                                    <span className="text-dark">
                                      {doctorInfo.discount}%
                                    </span>
                                  </div>

                                  <div className="d-flex justify-content-between">
                                    <span>
                                      <strong>Total Fee:</strong>
                                    </span>
                                    <span className="fw-bold text-success">
                                      {Math.round(
                                        doctorInfo.fee -
                                        (doctorInfo.fee *
                                          doctorInfo.discount) /
                                        100
                                      ).toLocaleString("en-US")}
                                    </span>
                                  </div>
                                </>
                              )} */}
                          </div>

                          <div className="d-flex gap-2 align-items-center ">
                            <strong>Status</strong>
                            <span className="text-danger flex-grow-1 text-end">
                              {doctorInfo.status}
                            </span>
                          </div>
                          {!isCouponApplied && (
                            <>
                              <div className="d-flex align-items-center">
                                <Form.Check
                                  type="checkbox"
                                  id="custom-checkbox"
                                  className="fw-normal wallet_checkbox"
                                  checked={isChecked}
                                  onChange={handleCheckboxChange}
                                />
                                <label className="mb-0 fw-light ms-2" style={{ color: "#50C4CC" }}>Follow Up Consultation</label>
                              </div>
                              {isChecked && (
                                <div className="mt-2 d-flex" style={{ gap: "10px" }}>
                                  <input
                                    style={{
                                      borderRadius: "8px",
                                      padding: "10px",
                                      border: "1px solid #00bcd4",
                                      fontSize: "12px"
                                    }}
                                    maxLength={64}
                                    type="text"
                                    className="form-control form-control-lg mb-0"
                                    placeholder="Enter Coupon Code"
                                    autoComplete="off"
                                    value={couponCode}
                                    onChange={(e) => setCouponCode(e.target.value)}
                                  />
                                  <button
                                    className="rounded-3"
                                    onClick={handleCouponSubmit}
                                  >
                                    Submit
                                  </button>
                                </div>
                              )}
                            </>

                          )}
                          {isCouponApplied && (
                            <div className="mt-2" style={{ color: "#50C4CC" }}>
                              🎉 50% discount applied for this slot! New fee:{" "}
                              <strong>
                                {Math.round(doctorInfo.fee).toLocaleString("en-US")} PKR
                              </strong>
                            </div>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      backgroundColor: "#e0f7fa",
                      padding: "15px",
                      borderRadius: "10px",
                      marginTop: "20px",
                    }}
                  >
                    <strong>Disclaimer</strong>

                    <p style={{ marginBottom: 0, fontSize: "12px" }}>
                      All doctor consultations and appointments conducted
                      through the WEBDOC platform are the sole responsibility of
                      the respective doctors. WEBDOC serves only as a
                      facilitating platform and does not assume any liability
                      for the medical advice, treatment, or outcomes resulting
                      from these consultations.
                    </p>
                  </div>
                </Modal.Body>

                <Modal.Footer>
                  <Button
                    variant="primary"
                    onClick={handleContinue}
                    className="animated-button"
                  >
                    Continue to Payment <span className="arrow">→</span>
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SelectAppointment;
